import { render, staticRenderFns } from "./FundraisingPlan.vue?vue&type=template&id=6d131420&scoped=true"
import script from "./FundraisingPlan.vue?vue&type=script&lang=js"
export * from "./FundraisingPlan.vue?vue&type=script&lang=js"
import style0 from "./FundraisingPlan.vue?vue&type=style&index=0&id=6d131420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d131420",
  null
  
)

export default component.exports